export default __webpack_public_path__ + "static/media/apple.1caa5ac8.svg";